import { render, staticRenderFns } from "./ComparadorPaginacion.vue?vue&type=template&id=506ff810"
import script from "./ComparadorPaginacion.vue?vue&type=script&lang=js"
export * from "./ComparadorPaginacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports